// @flow
import { LAST_SEEN_PRODUCTS } from 'Client/cms/toolkit/constants';
import { LastSeenProductsLine } from 'Components/lines/last-seen-products-line/LastSeenProductsLine';

export const lastSeenProductsDescriptor = {
  name: LAST_SEEN_PRODUCTS,
  component: LastSeenProductsLine,
};
